import { ForgotPassword } from '@jobcost-monorepo/ui';
import React from 'react';

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
